/* eslint-disable @typescript-eslint/no-explicit-any */

'use client';

import { Fragment, useState } from 'react';

import { useCustomSearchParams } from '@lamesarv-sdk/hooks';

import { FormContactInfo } from './FormContactInfo/FormContactInfo';
import { FormContactSell } from './FormContactSell/FormContactSell';
import { FormParts } from './FormParts/FormParts';
import { FormServiceAppointment } from './FormServiceAppointment/FormServiceAppointment';
import { FormVanUp } from './FormVanUp/FormVanUp';

import { IDynamicsOptionSet } from '@/types/dynamicsForms';

import { Modal } from '../Modal/Modal';

import { IComponentForm, PropsWithClasses, PropsWithTags } from '@lamesarv-sdk/types';
import { FormType } from '@/types/forms';

const getForm = (props: { formType: string; redirect?: string; className?: string }) => {
  switch (props.formType) {
    case FormType.contactInfo:
      return <FormContactInfo {...props} />;
    case FormType.contactSell:
      return <FormContactSell {...props} />;
    case FormType.serviceAppointment:
      return <FormServiceAppointment {...props} />;
    case FormType.parts:
      return <FormParts {...props} />;
    case FormType.vanUpfit:
      return <FormVanUp {...props} />;
    default:
      return <Fragment />;
  }
};

export interface IForm {
  formId: string;
  formType: string;
  leadType: string;
  leadSource?: string;
}

export interface IFormProps extends IComponentForm, PropsWithTags, PropsWithClasses {
  id?: string;
  modal?: boolean;
  modalUrlParameter?: string;
  locationsOptionSet?: IDynamicsOptionSet;
  successCallback?: () => void;
}

export const Form = (props: IFormProps) => {
  const { searchParams } = useCustomSearchParams();
  const modalOpenStatus =
    (props.modal && !props.modalUrlParameter) ||
    (props.modal && props.modalUrlParameter && !!searchParams.get(props.modalUrlParameter));
  const [modalOpen, setModalOpen] = useState(modalOpenStatus);

  if (props.modal) {
    return (
      <Modal isOpen={modalOpen} onClose={() => setModalOpen(false)} useMaxWidth={false} title={props.title}>
        {getForm({
          ...props,
          title: '',
          successCallback: () => {
            setTimeout(() => {
              setModalOpen(false);
            }, 2000);
          },
        } as any)}
      </Modal>
    );
  }

  return getForm(props);
};
